import React from 'react';

export default function DeliveryPolicy() {
    return (
        <div className="container">
            <header className="header">
                <h1>Delivery Policy</h1>
            </header>

            <section className="section">
               
                <p>All orders are subject to product availability. If an item in your order is
                    unavailable, we will ship you the part of your order that is available.
                    When that item becomes available, we will ship you the rest of your order.
                    Shipping costs for your order are non-refundable and are based on the weight
                    of the items you order and your location. </p>

                <p>
                    The date of delivery for your order
                    may vary due to carrier shipping practices, delivery location, method of delivery
                    and the quantity of items ordered
                </p>

                <table>
                    <tr>
                        <th>Shipping Type</th>
                        <th>Delivery Time</th>
                    </tr>

                    <tr>
                        <td>International Shipping</td>
                        <td>10 - 15 business days</td>
                    </tr>
                </table>

                <p>Please note that delivery times may vary based on external factors such as courier
                    delays, customs processing (for international orders), and holidays.
                    leathers crafts is not responsible for delays caused by shipping carriers or
                    any customs clearance procedures.</p>

                <p>
                    Your order may be delivered
                    in separate shipments. Additional shipping charges may apply depending on
                    your location and the size of your order. You are responsible for all taxes
                    applicable to the delivery of your order, including sales tax, value added
                    tax, custom duties and excise duties. If there is any damage to the items
                    that you ordered on delivery, you must contact us within 5 days from
                    receipt of your order.
                </p>

                <p>You will receive a confirmation email with tracking information once your 
                    order has shipped.</p>

                
            </section>


            {/* <section className="section">
                <h2>Delivery Policy (for Downloadable Goods ) </h2>
                <p>
                    Upon receipt of your order, you will either be prompted to begin your download
                    immediately or you will receive an e-mail from us with instructions to complete
                    your download. If you are prompted to begin your download immediately, your completion
                    of the download will constitute delivery to you of the item(s) you purchased.
                    If you receive an e-mail from us with instructions to complete your download,
                    the receipt by you of the e-mail will constitute delivery by us to you of the item(s)
                    you purchased. In case you are unable to download the item(s) you purchase or you
                    do not receive an e-mail from us with instructions to complete your download,
                    you must contact us within 5 days from the date of your order. If you do not contact
                    us within 5 days from the date of your order, the item(s) you purchased will be
                    considered received, downloaded and delivered to you.
                </p>
            </section> */}

            {/* <section className="section">
                <h2>Delivery Policy (for Services ) </h2>
                <p>
                    Upon receipt of your order, the services will be performed to you in accordance with
                    the terms applicable to the services that you purchased. The nature of the services
                    you purchased and the date of your purchase may impact the timing of performance of
                    the services. The services will be deemed to be successfully delivered to you upon
                    performance of the services.
                </p>
            </section> */}
        </div >
    );
}

